module.exports = __webpack_public_path__ + "static/img/IMG_20150310_163907.4676880b.jpg";